import { gql } from "@apollo/client";
import { CondensedTableFtePercentageCell_participant as Participant } from "../../../../__generated__/graphql";
import { AssembleTruncatedTypography } from "../../../../components/AssembleTruncatedTypography";
import { ColumnComponent2 } from "../CondensedTable/CondensedTableInner";
import { ColumnIds, ColumnIdsToHeaders } from "../Contexts/ColumnOrderContext";
import { SMALL_COL_WIDTH } from "./dimensions";

type Props = {
  row: { original: Participant };
};
export function CondensedTableFtePercentageCell({
  row: { original: employee },
}: Props): JSX.Element {
  const label = employee.subject.ftePercentage ?? 100;

  return (
    <AssembleTruncatedTypography align="right">
      {`${label}%`}
    </AssembleTruncatedTypography>
  );
}

CondensedTableFtePercentageCell.fragments = {
  participant: gql`
    fragment CondensedTableFtePercentageCell_participant on CompCycleParticipant {
      subject {
        ftePercentage
      }
    }
  `,
};

CondensedTableFtePercentageCell.Header = ColumnIdsToHeaders.get(
  ColumnIds.FTE_PERCENTAGE
);
CondensedTableFtePercentageCell.id = ColumnIds.FTE_PERCENTAGE;

const column: ColumnComponent2["column"] = {
  Cell: CondensedTableFtePercentageCell,
  Header: CondensedTableFtePercentageCell.Header,
  id: CondensedTableFtePercentageCell.id,
  width: SMALL_COL_WIDTH,
};
CondensedTableFtePercentageCell.column = column;
